import { combineReducers } from 'redux';
import account from './account';
import setting from './setting';
import notification from './notification';


export default combineReducers({
	account,
	setting,
	notification,
});